/* eslint-disable no-param-reassign */
import { useCallback } from 'react';
import { NOT_APPLICABLE } from 'common/constants/general';
import { DATA_UNAVAILABLE } from 'common/constants/valuations';
import { TransactionCompsAttributes } from 'pages/ValuationsAllocation/types';
import { SetNumericValues } from './useCapIqTransactions.types';

const useCapIqTransactions = (fieldAttributes?: TransactionCompsAttributes) => {
  const setNumericValues = useCallback<SetNumericValues>(
    (transactionRow, transactionData) => {
      const { transactionAttrs } = fieldAttributes ?? {};
      const {
        transaction_implied_enterprise_value,
        transaction_target_ltm_ebitda,
        transaction_target_ltm_revenue,
        transaction_target_ntm_ebitda,
        transaction_target_ntm_revenue,
        transaction_ebitda_margin,
        transaction_gross_margin,
      } = transactionData;
      const notAvailable = new Set([NOT_APPLICABLE, DATA_UNAVAILABLE, undefined, null]);

      if (notAvailable.has(transaction_implied_enterprise_value as string)) {
        transactionRow.enterprise_value = null;
      } else {
        transactionRow.enterprise_value = Number(transaction_implied_enterprise_value).toFixed(
          transactionAttrs?.enterprise_value?.decimal_places as number
        );
      }

      if (notAvailable.has(transaction_target_ltm_ebitda as string)) {
        transactionRow.ltm_ebitda = null;
      } else {
        transactionRow.ltm_ebitda = Number(transaction_target_ltm_ebitda).toFixed(
          transactionAttrs?.ltm_ebitda?.decimal_places as number
        );
      }

      if (notAvailable.has(transaction_target_ltm_revenue as string)) {
        transactionRow.ltm_revenue = null;
      } else {
        transactionRow.ltm_revenue = Number(transaction_target_ltm_revenue).toFixed(
          transactionAttrs?.ltm_revenue?.decimal_places as number
        );
      }

      if (notAvailable.has(transaction_target_ntm_ebitda as string)) {
        transactionRow.ntm_ebitda = null;
      } else {
        transactionRow.ntm_ebitda = Number(transaction_target_ntm_ebitda).toFixed(
          transactionAttrs?.ntm_ebitda?.decimal_places as number
        );
      }

      if (notAvailable.has(transaction_target_ntm_revenue as string)) {
        transactionRow.ntm_revenue = null;
      } else {
        transactionRow.ntm_revenue = Number(transaction_target_ntm_revenue).toFixed(
          transactionAttrs?.ntm_revenue?.decimal_places as number
        );
      }
      if (notAvailable.has(transaction_ebitda_margin as string)) {
        // if API does not return value for some reason try to calculate this specific field based on available data
        if (transactionRow.ltm_ebitda === null || transactionRow.ltm_revenue === null) {
          transactionRow.ltm_ebitda_margin = null;
        } else {
          transactionRow.ltm_ebitda_margin = (
            (Number(transactionRow.ltm_ebitda) / Number(transactionRow.ltm_revenue)) 
          ).toFixed(transactionAttrs?.ltm_ebitda_margin?.decimal_places as number);
        }
      } else {
        transactionRow.ltm_ebitda_margin = Number(transaction_ebitda_margin).toFixed(
          transactionAttrs?.ltm_ebitda_margin?.decimal_places as number
        );
      }
      if (notAvailable.has(transaction_gross_margin as string)) {
        transactionRow.ltm_gross_margin = null;
      } else {
        transactionRow.ltm_gross_margin = Number(transaction_gross_margin).toFixed(
          transactionAttrs?.ltm_gross_margin?.decimal_places as number
        );
      }
    },
    [fieldAttributes]
  );
  return {
    setNumericValues,
  };
};

export default useCapIqTransactions;
